import { render, staticRenderFns } from "./LandingComoList.vue?vue&type=template&id=e656b69a"
import script from "./LandingComoList.vue?vue&type=script&lang=js"
export * from "./LandingComoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports